import { HttpError, isBackendError } from "./http-error";

export const getNetworkErrorMessage = (response: unknown) => {
  if (response instanceof HttpError && isBackendError(response.data)) {
    return response.data.error.message;
  }
};
